import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  Paper,
  Skeleton,
} from "@mui/material";

const TablaGenerica = ({
  data = [],
  columns = [],
  loading = false,
  enablePagination = true,
  totalItems = 0,
  currentPage = 0,
  rowsPerPage = 10,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25, 50],
  tableStyle = { width: "100%", marginTop: "30px", padding: "10px" },
  emptyMessage = "No hay datos disponibles",
}) => {
  return (
    <>
      {loading ? (
        <TableSkeleton columns={columns} rowsNum={5} />
      ) : (
        <>
          <TableContainer component={Paper} sx={tableStyle}>
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((col, idx) => (
                    <TableCell
                      key={idx}
                      align={col.align || "center"}
                      sx={{
                        width: col.width,
                        minWidth: col.minWidth,
                        maxWidth: col.maxWidth,
                        px: col.padding,
                        py: col.verticalPadding,
                        ...(col.headerStyle || {}),
                      }}
                    >
                      {col.title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      {emptyMessage}
                    </TableCell>
                  </TableRow>
                ) : (
                  data.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {columns.map((col, colIndex) => (
                        <TableCell
                          key={colIndex}
                          align={col.align || "center"}
                          sx={{
                            width: col.width,
                            minWidth: col.minWidth,
                            maxWidth: col.maxWidth,
                            px: col.padding,
                            py: col.verticalPadding,
                            ...(col.cellStyle || {}),
                          }}
                        >
                          {col.render
                            ? col.render(row)
                            : row[col.field] ?? ""}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {enablePagination && data.length > 0 && (
            <TablePagination
              component="div"
              count={totalItems}
              page={currentPage}
              onPageChange={onPageChange}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={onRowsPerPageChange}
              rowsPerPageOptions={rowsPerPageOptions}
              labelRowsPerPage="Filas por página:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count}`
              }
            />
          )}
        </>
      )}
    </>
  );
};

const TableSkeleton = ({ columns, rowsNum }) => (
  <TableContainer component={Paper} sx={{ width: "100%", marginTop: "20px" }}>
    <Table>
      <TableHead>
        <TableRow>
          {columns.map((col, i) => (
            <TableCell key={i} align="center">
              {typeof col.title === "string" ? (
                col.title
              ) : (
                <Skeleton height={40} />
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(rowsNum)].map((_, rowIdx) => (
          <TableRow key={rowIdx}>
            {columns.map((_, colIdx) => (
              <TableCell key={colIdx}>
                <Skeleton height={24} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TablaGenerica;
